import React from 'react';
import Drawing from './Drawing';
import '../styles/MyDrawingSection.css';
function PeoplesDrawingSection(props) {
    return (
        <div>
            <h2 style={{backgroundColor:"gray", height:"50px"}}>Drawings by others</h2>
            <div className="gallary">
            <Drawing title="Beautiful Girl" submittedBy="Shreya"/>
            <Drawing title="Beautiful Girl" submittedBy="Shreya"/>
            <Drawing title="Beautiful Girl" submittedBy="Shreya"/>
            <Drawing title="Beautiful Girl" submittedBy="Shreya"/>
            <Drawing title="Beautiful Girl" submittedBy="Shreya"/>
            <Drawing title="Beautiful Girl" submittedBy="Shreya"/>
            <Drawing title="Beautiful Girl" submittedBy="Shreya"/>
        </div>
        </div>
    );
}

export default PeoplesDrawingSection;